import angular from 'angular';

export const componentsModule = angular.module(
  'portainer.docker.react.components',
  []
).name;
